export default __webpack_public_path__ + "static/media/task-square.87f4cd81.svg";